export default __webpack_public_path__ + "static/media/Edit Calendar.3ee179c7.svg";